import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetGuaranteeIdices } from "../guaranteesUXSlice";
import { PageIndex } from "../../../models";
import { setGuaranteesIndexThunk } from "../thunks/loadAllGuarantees";

export const useGuaranteeIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>(
    (s) => s.ux.clearing.guarantees.index
  );

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setGuaranteesIndexThunk(index)),
    [dispatch]
  );
  const dispatchResetIndex = React.useCallback(
    () => dispatch(resetGuaranteeIdices()),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex,
    typeof dispatchResetIndex
  ];
};
